import { ToastOptions } from 'ng2-toastr';

export class CustomToastOptions extends ToastOptions {
  enableHTML: true;
}



// WEBPACK FOOTER //
// ./src/app/_custom/toast-options.ts